import classNames from 'clsx';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { SEE_LESS, SEE_MORE } from '../../../constants/localizations/containerItems';
import useToggleState from '../../../hooks/useToggleState';
import { selectIsDiscord, selectIsMobile } from '../../../selectors/app';
import { selectIsNowPlayingDialogOpen } from '../../../selectors/dialog';
import ClampText from '../../shared/ClampText';
import CollapsibleLabel from '../../shared/CollapsibleLabel';
import sharedCss from '../shared/shared-card.module.scss';
import css from './episode-card.module.scss';

const EpisodeCard = ({ guideItem = {}, index }) => {
  const isDiscord = useSelector(selectIsDiscord);
  const [shouldShowMore, handleMoreClick] = useToggleState();
  const isMobile = useSelector(selectIsMobile);
  const isNowPlayingDialogOpen = useSelector(selectIsNowPlayingDialogOpen);

  // NOTE: MOBILE_ONLY_CHILD_LAYOUTS in `constants/childLayouts` lists this layout for the same
  // reason, so that a container holding only these never reaches the NowPlaying screen off mobile.
  if (!isMobile || !isNowPlayingDialogOpen) {
    return null;
  }

  const { title, subtitle, description, guideId } = guideItem;
  const duration = guideItem?.duration;
  const publishDate = guideItem?.publishDate;

  return (
    <div
      className={css.episodeCardContainer}
      data-testid={`guideItem-${index}`}
      data-testtype="episodeCard"
      data-nextguideitem={guideId}
    >
      {title && <div className={css.title}>{title}</div>}
      {subtitle && <div className={css.subtitle}>{subtitle}</div>}
      {description && (
        <>
          <ClampText clamp={shouldShowMore ? false : 6} className={css.description}>
            {description}
          </ClampText>
          {shouldShowMore && (publishDate || duration) && (
            <div className={css.dateAndDurationContainer}>
              {publishDate && <div data-testid="publishDate">{publishDate}</div>}
              {duration && <div data-testid="duration">{duration}</div>}
            </div>
          )}
          <CollapsibleLabel
            onMoreInfoClick={handleMoreClick}
            shouldShowMore={shouldShowMore}
            moreText={SEE_MORE}
            lessText={SEE_LESS}
            className={classNames(sharedCss.collapsibleLabel, {
              [sharedCss.isDiscord]: isDiscord,
            })}
            caretClassName={sharedCss.caret}
          />
        </>
      )}
    </div>
  );
};

EpisodeCard.propTypes = {
  guideItem: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default EpisodeCard;
